<template>
    <app-layout>
        <index-view
            :model="model"
        />
    </app-layout>
</template>

<script>
import {mapGetters} from "vuex";
import AppLayout from "../../layouts/AppLayout.vue";
import IndexView from "../../components/views/index/Index.vue";

export default {
    name: "MultiOrdersIndex",

    components: {
        IndexView,
        AppLayout,
    },

    computed: {
        ...mapGetters({
            model: 'multi-orders/getModel',
        })
    },
}
</script>

<style scoped>

</style>